import React from 'react';
import tableStyles from './AppointmentTable.module.css';
import actionStyles from './ActionButton/ActionButton.module.css';
import { ReactSVG } from 'react-svg';
import { Icons, TerminalsIcon } from '@/assets';
import timeAgo from '@/ctUtlis/timeAgo';
import CloseButton from '../closeButton';

export default function CloseAlert({
  handleClose,
  time,
  terminal,
  date,
  shift,
  data,
}) {
  const formattedDate =
    date && date.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1');
  const shiftLabel = shift === 1 ? '1st' : '2nd';
  const fallbackLastChecked = timeAgo(time);
  const gateChecked = data?.gate_update
    ? timeAgo(data?.gate_update)
    : fallbackLastChecked;
  const restrictionChecked = data?.restriction_update
    ? timeAgo(data?.restriction_update)
    : fallbackLastChecked;

  return (
    <div
      className={actionStyles.card}
      style={{ minHeight: 'auto', maxHeight: 'none' }}>
      <div className={actionStyles.cardContent}>
        {/* Top info row: terminal, date, shift */}
        <div className={actionStyles.content}>
          <div className={actionStyles.logoSection}>
            <a
              className={actionStyles.terminalLink}
              target="_blank"
              rel="noreferrer">
              <img
                width={100}
                src={
                  terminal
                    ? TerminalsIcon[terminal?.replace(/\s+/g, '')]
                    : undefined
                }
                alt={terminal || 'terminal'}
              />
            </a>
            <div className={actionStyles.verticalDashed} />
          </div>
          <div className={actionStyles.details}>
            <div className={actionStyles.detailItem}>
              <ReactSVG src={Icons.calendarday} className={actionStyles.icon} />
              Date:{' '}
              <span className={actionStyles.boldText}>{formattedDate}</span>
            </div>
            <div className={actionStyles.detailItem}>
              <ReactSVG src={Icons.clocktime} className={actionStyles.icon} />
              Shift: <span className={actionStyles.boldText}>{shiftLabel}</span>
            </div>
          </div>
        </div>

        {/* Middle list: Gate & Receiving statuses */}
        <div className={actionStyles.statusList}>
          {data?.gate_status !== null && data?.gate_status !== undefined && (
            <div className={actionStyles.statusRow}>
              <div className={actionStyles.statusLeft}>
                <ReactSVG
                  src={
                    data?.gate_status === 1
                      ? Icons.tickCircle
                      : Icons.closeCircle
                  }
                  className={
                    data?.gate_status === 1
                      ? actionStyles.statusOpenIconContainer
                      : actionStyles.statusCloseIconContainer
                  }
                />
                <div className={actionStyles.statusTexts}>
                  <span className={actionStyles.statusTitle}>
                    {data?.gate_status === 1 ? 'Gate Open' : 'Gate Closed'}
                  </span>
                  <span className={actionStyles.statusSubtext}>
                    Gate status last checked <strong>{gateChecked}</strong>
                  </span>
                </div>
              </div>
              <div className={actionStyles.statusScreenshotDisabled}>
                <ReactSVG
                  src={Icons.screenshoteye}
                  className={actionStyles.screenshoteye}
                />
                <span>View Screenshot</span>
              </div>
            </div>
          )}

          {data?.restriction_status !== null &&
            data?.restriction_status !== undefined && (
              <div className={actionStyles.statusRow}>
                <div className={actionStyles.statusLeft}>
                  <ReactSVG
                    src={
                      data?.restriction_status === 1
                        ? Icons.tickCircle
                        : Icons.closeCircle
                    }
                    className={
                      data?.restriction_status === 1
                        ? actionStyles.statusOpenIconContainer
                        : actionStyles.statusCloseIconContainer
                    }
                  />
                  <div className={actionStyles.statusTexts}>
                    <span className={actionStyles.statusTitle}>
                      {data?.restriction_status === 1
                        ? 'Open for Receiving'
                        : 'Closed for Receiving'}
                    </span>
                    <span className={actionStyles.statusSubtext}>
                      Receiving schedule last checked{' '}
                      <strong>{restrictionChecked}</strong>
                    </span>
                  </div>
                </div>
                <div className={actionStyles.statusScreenshotDisabled}>
                  <ReactSVG
                    src={Icons.screenshoteye}
                    className={actionStyles.alertpicContainer}
                  />
                  <span>View Screenshot</span>
                </div>
              </div>
            )}
        </div>

        {/* Footer: only Close button */}
        <div className={actionStyles.footer}>
          <div />
          <div className={actionStyles.buttonsContainer}>
            <CloseButton
              onClick={() => {
                handleClose();
              }}
              text={'Close'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
